import { Outlet } from 'react-router-dom';

function Validacion() {
  return <Outlet />;
}

export default Validacion;
